// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"c83e7e6c","82":"d0a151a4","247":"61e0cf6e","256":"c6bca515","284":"d1fd8fed","358":"bc104d56","422":"f939361f","627":"64b2d76c","834":"ce31a2ec","867":"8d87d81a","923":"3063f7e5","938":"21dcd9a4"}[chunkId] + ".chunk.js";
};